// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonPanningMode_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16 9.0566V3.42138C16 2.31447 15.0943 1.50943 13.9874 1.50943C13.4843 1.50943 13.0818 1.71069 12.7799 1.91195C12.3774 1.30818 11.7736 0.90566 11.0692 0.90566C10.566 0.90566 10.0629 1.10692 9.76101 1.40881C9.35849 0.805031 8.75472 0.503145 8.05031 0.503145C7.54717 0.503145 7.04403 0.704403 6.64151 1.00629C6.23899 0.402516 5.53459 0 4.83019 0C3.62264 0 2.61635 1.00629 2.61635 2.11321C2.61635 2.11321 2.61635 2.11321 2.61635 2.21384V3.42138C1.71069 4.02516 0 5.33333 0 6.74214C0 7.94969 0.100629 8.15094 1.10692 9.55975C2.01258 10.8679 5.63522 15.3962 5.73585 15.5975L6.03774 16H13.6855L16 9.0566ZM14.1887 3.8239V8.55346L12.3774 14.0881H6.9434C6.03774 12.9811 3.42138 9.55975 2.61635 8.45283C1.91195 7.34591 1.91195 7.34591 1.91195 6.74214C1.91195 6.54088 2.21384 6.23899 2.61635 5.83648V6.33962C2.61635 6.84277 3.01887 7.24528 3.52201 7.24528C4.02516 7.24528 4.42767 6.84277 4.42767 6.33962V2.41509C4.42767 2.11321 4.62893 1.91195 4.93082 1.91195C5.23271 1.91195 5.43396 2.11321 5.43396 2.41509V4.02516C5.53459 4.62893 5.93711 5.03145 6.54088 5.03145C7.14465 5.03145 7.44654 4.62893 7.44654 4.12579V2.91824C7.44654 2.61635 7.6478 2.41509 7.94969 2.41509C8.25157 2.41509 8.45283 2.61635 8.45283 2.91824V4.72956C8.45283 5.2327 8.85535 5.63522 9.35849 5.63522C9.86164 5.63522 10.2642 5.2327 10.2642 4.72956V3.32075C10.2642 3.01887 10.4654 2.81761 10.7673 2.81761C11.0692 2.81761 11.2704 3.01887 11.2704 3.32075V5.2327C11.2704 5.73585 11.673 6.03774 12.1761 6.03774C12.6792 6.03774 13.0818 5.63522 13.0818 5.2327V3.8239C13.0818 3.52201 13.283 3.32075 13.5849 3.32075C13.8868 3.32075 14.1887 3.52201 14.1887 3.8239Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonPanningMode is a generated icon component.
 */
let IconCommonPanningMode = IconCommonPanningMode_1 = class IconCommonPanningMode extends IconBaseElement {
    render() {
        return html `${IconCommonPanningMode_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonPanningMode.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonPanningMode = IconCommonPanningMode_1 = __decorate([
    customElement('zui-icon-common-panning-mode')
], IconCommonPanningMode);
export { IconCommonPanningMode };
